/**
 * "Today" as the ops team sees it — YYYY-MM-DD in the ops timezone.
 *
 * One definition shared by the Senior list (date picker, counts query) and
 * the Senior detail page's queue footer (SPEC-3 senior-prefs §4: the footer
 * is always today, using the same helper the list uses), so the two can never
 * disagree about which day "today" is around midnight.
 */
import { OPS_TZ } from "@/lib/ops-tz";

export function todayEtString(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: OPS_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}
